var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2929 10.3185C23.6834 9.92801 23.6834 9.29485 23.2929 8.90432L23.0957 8.70711C22.7052 8.31658 22.072 8.31658 21.6815 8.70711L16 14.3886L10.3185 8.70711C9.92801 8.31658 9.29485 8.31658 8.90432 8.70711L8.70711 8.90432C8.31658 9.29485 8.31658 9.92801 8.70711 10.3185L14.3886 16L8.70711 21.6815C8.31658 22.072 8.31658 22.7052 8.70711 23.0957L8.90432 23.2929C9.29485 23.6834 9.92801 23.6834 10.3185 23.2929L16 17.6114L21.6815 23.2929C22.072 23.6834 22.7052 23.6834 23.0957 23.2929L23.2929 23.0957C23.6834 22.7052 23.6834 22.072 23.2929 21.6815L17.6114 16L23.2929 10.3185Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/CloseBtn.0f5bdbc694635e3d52c0d92ac44aa17f.svg";
export { ForwardRef as ReactComponent };